// Password validation rules matching Django AUTH_PASSWORD_VALIDATORS
// Source: frogger/settings.py lines 295-308

// MinimumLengthValidator default is 8
export const MIN_PASSWORD_LENGTH = 8;

export const PASSWORD_RULES = [
  {
    id: 'min-length',
    label: `At least ${MIN_PASSWORD_LENGTH} characters`,
    validate: (password) => password.length >= MIN_PASSWORD_LENGTH,
  },
  {
    id: 'not-common',
    label: 'Not a commonly used password',
    validate: (password) => {
      // Client-side check for obvious common passwords
      const commonPasswords = [
        'password', 'password123', '12345678', 'qwerty', 'abc123',
        'monkey', '1234567890', 'letmein', 'trustno1', 'dragon',
        'baseball', 'iloveyou', 'master', 'sunshine', 'ashley',
        'bailey', 'passw0rd', 'shadow', '123123', '654321'
      ];
      return !commonPasswords.includes(password.toLowerCase());
    },
  },
  {
    id: 'not-numeric',
    label: 'Not entirely numeric',
    validate: (password) => !/^\d+$/.test(password),
  },
];

// Map backend error messages to friendly user-facing messages
export const mapPasswordError = (errorMessage) => {
  if (!errorMessage) return null;

  const msg = errorMessage.toLowerCase();

  // MinimumLengthValidator
  if (msg.includes('too short') || msg.includes('at least')) {
    const match = errorMessage.match(/(\d+)/);
    const minLength = match ? match[1] : MIN_PASSWORD_LENGTH;
    return `Password must be at least ${minLength} characters.`;
  }

  // CommonPasswordValidator
  if (msg.includes('too common') || msg.includes('common password')) {
    return 'That password is too common. Choose something more unique.';
  }

  // NumericPasswordValidator
  if (msg.includes('entirely numeric') || msg.includes('all numbers')) {
    return "Password can't be all numbers.";
  }

  // Password mismatch
  if (msg.includes("didn't match") || msg.includes("don't match")) {
    return "Passwords don't match.";
  }

  // UserAttributeSimilarityValidator
  if (msg.includes('similar to') || msg.includes('too similar')) {
    return 'Password is too similar to your email or other information.';
  }

  // Return original if no match
  return errorMessage;
};

// Map backend email error messages to friendly user-facing messages
export const mapEmailError = (errorMessage) => {
  if (!errorMessage) return null;

  const msg = errorMessage.toLowerCase();

  // Duplicate email
  if (msg.includes('already registered') || msg.includes('already exists')) {
    return 'That email is already registered. Try logging in.';
  }

  // Invalid format
  if (msg.includes('valid email') || msg.includes('invalid email')) {
    return 'Enter a valid email address.';
  }

  // Return original if no match
  return errorMessage;
};
